import script from "./simulator.vue?vue&type=script&setup=true&lang=js"
export * from "./simulator.vue?vue&type=script&setup=true&lang=js"

import "./simulator.vue?vue&type=style&index=0&id=01d8907c&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d8907c"]])

export default __exports__